import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';
import { PublicBoxStatusBadgeComponent } from '../public-box-status-badge/public-box-status-badge.component';
import { Nillable } from '@web/utils';
import { PublicAvailability } from '@web/shared/module/shop';

@Component({
  selector: 'app-public-box-tile-image',
  imports: [
    ImageThumbnailComponent,
    NgOptimizedImage,
    PublicBoxStatusBadgeComponent,
  ],
  templateUrl: './public-box-tile-image.component.html',
  styleUrl: './public-box-tile-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxTileImageComponent {
  public readonly imageAlt = input<Nillable<string>>();
  public readonly imageSrc = input<Nillable<string>>();
  /* prettier-ignore */
  public readonly availability = input.required<PublicAvailability>();
}
